import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'

const Vcard = ({ vcardDescription, vcardImage, vcardLink, vcardName, vcardTitle }) => {
  return (
    <div className="Vcard">
      <div className="Vcard-imageWrapper">
        <div className="Vcard-imageContainer">
          <img
            className="Vcard-image"
            src={vcardImage.length ? vcardImage[0].url : '/images/vcard-none.jpg'}
            alt={vcardImage.alt ? vcardImage[0].alt : ''}
          />
        </div>
      </div>
      <div className="Vcard-infoWrapper">
        {vcardName && <h3 className="Vcard-name">{vcardName}</h3>}
        {vcardTitle && <h4 className="Vcard-title">{vcardTitle}</h4>}
        {vcardDescription && <p className="Vcard-description">{vcardDescription}</p>}
        {vcardLink && (
          <ul className="Vcard-contact">
            {vcardLink.map((vcardCred, index) => {
              return (
                <li key={index} className={`Vcard-contactItem Vcard-contactItem-${vcardCred.type}`}>
                  <Svg id={`icon-${vcardCred.type}`} modifiers={['Vcard-iconSvg']} />
                  {vcardCred.type === 'email' || vcardCred.type === 'url' ? (
                    <a
                      className="Vcard-link"
                      target={vcardCred.type === 'email' || vcardCred.type === 'url' ? '_blank' : ''}
                      rel="noreferrer"
                      href={`${vcardCred.type === 'url' ? 'http://' : ''}${
                        vcardCred.type === 'email' ? 'mailto:' : ''
                      }${vcardCred.value}`}
                    >
                      {vcardCred.value}
                    </a>
                  ) : (
                    vcardCred.value
                  )}
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </div>
  )
}

Vcard.propTypes = {
  vcardDescription: PropTypes.string,
  vcardImage: PropTypes.array,
  vcardLink: PropTypes.array,
  vcardName: PropTypes.string,
  vcardSubtitle: PropTypes.string,
  vcardTitle: PropTypes.string
}

export default Vcard
